export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Nuun+Kebabs+Mallikatte+Kadri+Mangaluru";
export const INSTAGRAM_URL = "https://www.instagram.com/nuunkebabs.mlr/";
export const MAPS_EMBED =
  "https://maps.google.com/maps?q=Nuun%20Kebabs%2C%20Mallikatte%2C%20Kadri%2C%20Mangaluru&z=16&output=embed";

export const IMG = {
  hero: "https://images.unsplash.com/photo-1761095596559-a99659d772dd?crop=entropy&cs=srgb&fm=jpg&q=85",
  skewer:
    "https://images.unsplash.com/photo-1613628068926-0a5562f4aa9e?crop=entropy&cs=srgb&fm=jpg&q=85",
  platter:
    "https://images.pexels.com/photos/37206710/pexels-photo-37206710.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  hummus:
    "https://images.pexels.com/photos/6252739/pexels-photo-6252739.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720",
  wrap: "https://images.pexels.com/photos/11286814/pexels-photo-11286814.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720",
};

export const CATEGORIES = [
  "All",
  "Seekhs & Kebabs",
  "Lapeta & Rolls",
  "Mezze & Sides",
  "Mojitos & Coolers",
];

/* Dishes sourced from Google reviews & the restaurant's Instagram (@nuunkebabs.mlr).
   Prices shown only where publicly posted; others are asked at the counter. */
export const MENU = [
  {
    slug: "mutton-adana",
    name: "Mutton Adana Kebab",
    cat: "Seekhs & Kebabs",
    price: null,
    tag: "Review favourite",
    desc: "Hand-pressed spiced mutton on flat iron skewers, char-grilled over glowing embers — flavourful, juicy, well-seasoned.",
  },
  {
    slug: "chicken-sultana",
    name: "Chicken Sultana",
    cat: "Seekhs & Kebabs",
    price: null,
    tag: "Review favourite",
    desc: "Tender chicken steeped in an aromatic marinade, grilled juicy with a gentle smoky crust. A house signature.",
  },
  {
    slug: "shish-tawook",
    name: "Chicken Shish Tawook",
    cat: "Seekhs & Kebabs",
    price: null,
    tag: "Review favourite",
    desc: "The classic Arab garlic-and-lemon chicken skewer — charred edges, soft centre, pure tawook tradition.",
  },
  {
    slug: "chicken-chihan",
    name: "Chicken Chihan Kebab",
    cat: "Seekhs & Kebabs",
    price: "₹279",
    tag: "10/10",
    desc: "Robustly seasoned chicken seekh, finished hot off the grill. Rated a perfect 10 by our first food critics.",
  },
  {
    slug: "turkish-wings",
    name: "Turkish Wings",
    cat: "Seekhs & Kebabs",
    price: null,
    tag: "9/10",
    desc: "Crisp-edged wings in a Turkish pepper rub, smoked slowly over charcoal.",
  },
  {
    slug: "spicy-wings",
    name: "Spicy Wings",
    cat: "Seekhs & Kebabs",
    price: "₹199",
    tag: "10/10",
    desc: "Fiery glazed wings with Arab chilli paste — not for the timid.",
  },
  {
    slug: "mutton-seekh-lapeta",
    name: "Mutton Seekh Lapeta",
    cat: "Lapeta & Rolls",
    price: null,
    tag: "10/10 · Must try",
    desc: "Smoky mutton seekh wrapped tight in hot buttered flatbread with pickled onion and house sauce. The one everyone talks about.",
  },
  {
    slug: "chicken-adana-lapeta",
    name: "Chicken Adana Lapeta",
    cat: "Lapeta & Rolls",
    price: null,
    tag: "Lapeta series",
    desc: "Char-grilled chicken adana — wrapped, loaded and packed with flavour.",
  },
  {
    slug: "sulthan-roll",
    name: "Sulthan Chicken Roll",
    cat: "Lapeta & Rolls",
    price: "₹179",
    tag: "9.5/10",
    desc: "Flame-broiled chicken strips, crisp greens and garlic spread rolled into a warm flatbread.",
  },
  {
    slug: "hummus",
    name: "Hummus with Pita",
    cat: "Mezze & Sides",
    price: null,
    tag: "Review favourite",
    desc: "Silky chickpea-tahini hummus, extra virgin olive oil, warm pita. The cool, creamy pause between smoke and fire.",
  },
  {
    slug: "blacksalt-mojito",
    name: "Blacksalt Mojito",
    cat: "Mojitos & Coolers",
    price: "₹70",
    tag: "9.5/10",
    desc: "Lime, mint and digestive black salt over crushed ice — the house cooler.",
  },
  {
    slug: "lemon-mint-mojito",
    name: "Lemon Mint Mojito",
    cat: "Mojitos & Coolers",
    price: null,
    tag: "Fresh & zesty",
    desc: "Fresh, zesty and made to hit the spot — the break between spice and smoke.",
  },
];

export const SPOTLIGHT = [
  { slug: "mutton-seekh-lapeta", img: IMG.wrap },
  { slug: "chicken-sultana", img: IMG.skewer },
  { slug: "hummus", img: IMG.hummus },
];

export const REVIEWS = [
  {
    author: "Rahil Marzan",
    meta: "Local Guide · 81 reviews · a week ago",
    text: "Had a really good visit to Nuun Kebabs. The kebabs were freshly served and nicely prepared. I tried the Mutton Adana and Chicken Sultana — both were flavorful, juicy, and well-seasoned. A simple but satisfying kebab experience.",
  },
  {
    author: "Nashath Khadeeja",
    meta: "5 reviews · a week ago",
    text: "Really loved the food at Nuun Kebabs! My personal favourites were the Chicken Sultana, Chicken Shish Tawook and the hummus — everything was so flavourful and delicious. The place has a lovely vibe too. Definitely recommend trying these dishes if you're visiting!",
  },
];

export const REVIEWERS = ["Rahil Marzan", "Nashath Khadeeja", "Nizam Nazeer"];

export const CHAPTERS = [
  {
    n: "01",
    title: "The charcoal flame",
    text: "Every skewer at Nuun meets real glowing embers — searing heat, honest spice rubs and that unmistakable smoky char. Freshly served, nicely prepared. Nothing else needed.",
  },
  {
    n: "02",
    title: "The Arab way",
    text: "Adana, Sultana, Shish Tawook — timeless Arab grill traditions, hand-pressed and marinated the slow way, served in the heart of Mallikatte, Kadri.",
  },
  {
    n: "03",
    title: "The evening table",
    text: "We light the coals at 4 PM and grill till 11:30 PM. Bring your people — kebabs, lapeta rolls and chilled mojitos under one smoky, lovely vibe.",
  },
];

export const MARQUEE_ITEMS = [
  "Mutton Adana",
  "Chicken Sultana",
  "Shish Tawook",
  "Mutton Seekh Lapeta",
  "Chicken Chihan",
  "Turkish Wings",
  "Hummus",
  "Blacksalt Mojito",
];
